<template>
    <div class="engineering">
        <el-container>
            <el-main ref="main" style="height: 80%;">
                <el-tabs  v-model="activeName" style="width: 100%">
                    <el-tab-pane label="预计成本" name="Tab1" style="height: 100%;overflow-y: auto">
                        <div class="moduleList">
                            <delete-module class="deleteModule" :list.sync="engineerList.laborExpectList" :index="1" titleTxt="劳务信息" :isShowBtn="true" @refreshDataList="getFrontDetail"></delete-module>
                            <delete-module class="deleteModule" :list.sync="engineerList.materialExpectList" :index="1" titleTxt="材料信息" :isShowBtn="true" @refreshDataList="getFrontDetail"></delete-module>
                            <delete-module class="deleteModule" :list.sync="engineerList.machineExpectList" :index="1" titleTxt="机械信息" :isShowBtn="true" @refreshDataList="getFrontDetail"></delete-module>
                            <delete-module class="deleteModule" :list.sync="engineerList.otherExpectList" :index="1" titleTxt="其他" :isShowBtn="true" @refreshDataList="getFrontDetail"></delete-module>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="实际成本" name="Tab2" style="height: 100%;overflow-y: auto">
                        <div v-for="(partyActItem,partyActIndex) in engineerList.partyActList"
                            :key="'partyActItem'+ partyActIndex">
                            <div class="partyBName">{{partyActItem.partyBName}}:</div>
                            <div class="moduleList">
                                <delete-module class="deleteModule" :list.sync="partyActItem.laborActList" :index="2" titleTxt="劳务信息" :isShowBtn="true" @refreshDataList="getFrontDetail"></delete-module>
                                <delete-module class="deleteModule" :list.sync="partyActItem.materialActList" :index="2" titleTxt="材料信息" :isShowBtn="true" @refreshDataList="getFrontDetail"></delete-module>
                                <delete-module class="deleteModule" :list.sync="partyActItem.machineActList" :index="2" titleTxt="机械信息" :isShowBtn="true" @refreshDataList="getFrontDetail"></delete-module>
                                <delete-module class="deleteModule" :list.sync="partyActItem.otherActList" :index="2" titleTxt="其他" :isShowBtn="true" @refreshDataList="getFrontDetail"></delete-module>
                            </div>
                        </div>
                        <div class="noDataTxt" v-if="engineerList.partyActList.length== 0">暂无实际成本</div>
                    </el-tab-pane>
                </el-tabs>
            </el-main>
            <el-footer class="container" style="margin-top: 30px">
                <div class="btnMid">
                    <el-button type="primary" v-if="isShowDeleteBtn" @click="deleteItem()">删除总包细目</el-button>
                    <el-button type="info" @click="reset()">关 闭</el-button>
                </div>
            </el-footer>
        </el-container>

    </div>
</template>

<script>
    import deleteModule from '../delete-module'
    import {
        batchDeleteMiddleDataService,
        queryMiddleDetailService,
    } from '../../../services/engineering'
    export default {
        name: "inTheDeleteDetail",
        data(){
            return {
                activeName: 'Tab1',
                isShowDeleteBtn: false,
                projectDetailsFrontId: '',
                engineerList: [],
            }
        },
        components:{
            deleteModule
        },
        methods:{
            onActive(menuCode) {
                this.middleId = this.tabRouteParam.id
                this.isShowDeleteBtn = this.tabRouteParam.isShowDeleteBtn
                this.getFrontDetail()
            },
            getFrontDetail(){
                let paramsData = {
                    middleId: this.middleId
                }
                queryMiddleDetailService(paramsData).then( res => {
                    if(res.code == 10000000){
                        this.engineerList = res.data;
                        this.$forceUpdate()
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            deleteItem(){
                this.$confirm('此操作将永久删除该总包细目, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let params = {
                        ids: [this.middleId]
                    }
                    batchDeleteMiddleDataService(params).then(res => {
                        if(res.code == 10000000){
                            this.$message.success('删除成功');
                            this.reset();
                        }
                    })
                }).catch(() => {

                });
            },
            reset(){
                this.bus.$emit("tabClose", "inTheDeleteDetail");
                this.bus.$emit("navMenuChange", {
                    routeId: "inTheIndex"
                });
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "@/assets/css/commonLayout.scss";
    .engineering {
        height: 100%;
        background-color: white;
        display: flex;
        flex-direction: column;
        .container{
            width: 900px;
            .btnMid {
                width: 300px;
                margin: 0 auto;
                display: flex;
                justify-content: space-around;
            }
        }
    }
    .partyBName {
        width: 300px;
        font-size: 18px;
        font-weight: 600;
    }
    .moduleList{
        width: 90%;
        .deleteModule{
            width: 100%;
        }
    }
    .noDataTxt {
        height: 100%;
        font-size: 16px;
        font-weight: 600;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    /deep/.el-tabs__item{
        padding: 0 20px !important;
    }
</style>

